import React from "react";
import styles from "./templates.module.css";
import { renderWhatsAppRichText } from "../../utils/whatsappRichText";

export default function TemplatePreview({
  header,
  body,
  footer,
  buttons,
  originalHeader,
  originalBody,
  mode = "message",
  onModeChange,
}) {
  const showOriginal = mode === "template";
  const activeHeader = showOriginal ? originalHeader : header;
  const activeBody = showOriginal ? originalBody : body;

  return (
    <aside className={styles.preview}>
      <div className={styles.previewTabs}>
        <button
          type="button"
          className={`${styles.previewTab} ${!showOriginal ? styles.previewTabActive : ""}`}
          onClick={() => onModeChange?.("message")}
        >
          Message Preview
        </button>
        <button
          type="button"
          className={`${styles.previewTab} ${showOriginal ? styles.previewTabActive : ""}`}
          onClick={() => onModeChange?.("template")}
        >
          Template
        </button>
      </div>
      <div className={styles.phoneBg}>
        <div className={styles.bubble}>
          {activeHeader ? <div className={styles.previewHeader}>{renderWhatsAppRichText(activeHeader)}</div> : null}
          <div className={styles.previewBody}>{renderWhatsAppRichText(activeBody || "")}</div>
          {footer ? <div className={styles.previewFooter}>{renderWhatsAppRichText(footer)}</div> : null}
          <div className={styles.previewTime}>{new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</div>
          {(buttons || []).map((b, idx) => (
            <div className={styles.previewButton} key={`${b.text}-${idx}`}>
              {b.text || "Button"}
            </div>
          ))}
        </div>
      </div>
    </aside>
  );
}
